import axios from 'axios';
import type {
  ListContactType,
  IContactListRequest,
  IContactListResponse,
  ContactListSortOrder,
} from '@bb/contacts';

const getContactsList = async (
  listType: ListContactType,
  startIndex: number,
  limit: number,
  sort?: {
    field: string;
    order: ContactListSortOrder;
  },
  filters?: Record<string, string[]>,
  searchRelated?: boolean,
  getCount?: boolean,
) => {
  const config: IContactListRequest = {
    url: '/contacts',
    params: {
      type: listType,
      start: startIndex,
      sortBy: sort?.field,
      sortOrder: sort?.order,
      filters,
      limit,
      searchRelated,
      getCount,
    },
    method: 'get',
  };

  const { data } = await axios.request<IContactListResponse>(config);
  return data;
};

export default getContactsList;
